/** Signes diacritiques isolés par `normalize('NFD')` (bloc Unicode « Combining Diacritical Marks »). */
const DIACRITICS = new RegExp(`[${String.fromCharCode(0x300)}-${String.fromCharCode(0x36f)}]`, 'g');

const DEFAULT_MAX_LENGTH = 60;

/**
 * « Val-d'Oise » → « val-d-oise ». Au-delà de `maxLength`, coupe sur un tiret :
 * une URL ne doit pas couper un mot en deux.
 */
export function slugify(value: string, maxLength = DEFAULT_MAX_LENGTH): string {
  const slug = value
    .normalize('NFD')
    .replace(DIACRITICS, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (slug.length <= maxLength) return slug;
  const cut = slug.slice(0, maxLength);
  const lastDash = cut.lastIndexOf('-');
  return (lastDash > 0 ? cut.slice(0, lastDash) : cut).replace(/-+$/, '');
}
